import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  createCategoryAction,
  updateCategoryAction,
} from "../../../store/actions/CategoryAction";
import { showErrorAlert } from "../../../services/ErrorHandlingService";
import Loader from "../Common/Loader";

const AddCategories = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const category = location.state?.category || null;

  const [form, setForm] = useState({
    category_name: "",
    category_description: "",
    category_status: "Active",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  useEffect(() => {
    if (id && category) {
      setFetching(true);
      setErrors({});
      setForm({
        category_name: category.category_name || "",
        category_description: category.category_description || "",
        category_status: category.category_status || "",
      });
      setFetching(false);
    }
  }, [id, category]);


  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    // remove error instantly
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  

  const handleStatusChange = (selectedOption) => {
    setForm((prev) => ({
      ...prev,
      category_status: selectedOption ? selectedOption.value : "",
    }));
  
    // clear status error
    setErrors((prev) => ({
      ...prev,
      category_status: "",
    }));
  };
  

  const validate = () => {
    const newErrors = {};
    if (!form.category_name.trim()) newErrors.category_name = "Please Enter Category name";

    if (!form.category_status) newErrors.category_status = "Status is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
  
    if (!validate()) {
      setLoading(false);
      return;
    }
  
    try {
      if (id) {
        await dispatch(updateCategoryAction(form, id));
      } else {
        await dispatch(createCategoryAction(form));
      }
      navigate("/categories");
    } catch (error) {
      console.error("Form submission failed:", error);
      showErrorAlert(
        id ? "Failed to update category" : "Failed to add category"
      );
    } finally {
      setLoading(false);
    }
  };
  

  if (fetching) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <Loader size="lg" />
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="d-flex justify-content-end p-3">
          <Link to="/categories">
            <Button variant="primary">Back</Button>
          </Link>
        </div>
        <div className="card">
          <div className="card-body">
            <h4 className="mb-4">
              {id ? "Edit Category" : "Add New Category"}
            </h4>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-12 mb-3">
                  <label className="form-label">Category Name</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="text"
                    className="form-control"
                    name="category_name"
                    placeholder="Enter Category Name"
                    value={form.category_name}
                    onChange={handleChange}
                  />
                  {/* {errors.category_name && (
                    <div className="invalid-feedback">
                      {errors.category_name}
                    </div>
                  )} */}
                  {errors.category_name && <small className="text-danger">{errors.category_name}</small>}
                </div>
              </div>

              <div className="row">
                <div className="col-xl-12 mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    name="category_description"
                    placeholder="Enter Description (optional)"
                    value={form.category_description}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>

              <div className="row">
              <div className="col-xl-6 mb-3">
  <label className="form-label">
    Status <span className="text-danger">*</span>
  </label>

  <Select
    options={statusOptions}
    value={statusOptions.find(
      (opt) => opt.value === form.category_status
    )}
    onChange={handleStatusChange}
    placeholder="Select Status"
    isClearable
    styles={{
      control: (provided) => ({
        ...provided,
        minHeight: "50px",
        height: "50px",
        borderColor: errors.category_status
          ? "#dc3545"
          : provided.borderColor,
        boxShadow: errors.category_status
          ? "0 0 0 0.2rem rgba(220,53,69,.25)"
          : provided.boxShadow,
      }),
      singleValue: (provided) => ({
        ...provided,
        lineHeight: "50px",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: "4px",
      }),
      indicatorSeparator: () => ({
        display: "none",
      }),
    }}
  />

  {errors.category_status && (
    <small className="text-danger">{errors.category_status}</small>
  )}
</div>

              </div>

              <div className="row">
                <div className="col-xl-12">
                <button type="submit" className="btn btn-primary me-2" disabled={loading || fetching}>
                  {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">Submitting...</span>
                  </>
                ) : (
                  <>{id ? "Update Category" : "Add Category"}</>
                )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCategories;
